import React from 'react';
import './bootstrap.min.css'; 
import { NavLink } from 'react-router-dom';

function Footer() {

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <div className="container-fluid footer bg-dark text-light mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">

                        {/* Logo & Description */}
                        <div className="col-lg-3 col-md-6">
                            <div>
                                <img 
                                    src={`${process.env.PUBLIC_URL}/img/logo.png`} 
                                    className="img-fluid mb-4"
                                    style={{ width: "50px",height:"50px" }}
                                    alt="Unicell Technologies Logo"
                                />
                            </div>
                            <p className="text-white-50">
                                Unicell Technologies Limited is a leading industrial solutions provider 
                                specializing in paper mills, plastic recycling, and renewable biomass energy 
                                across the globe.
                            </p>
                            <div className="d-flex pt-2">
                                <a className="btn btn-outline-light btn-social me-2" href="#"><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-outline-light btn-social me-2" href="#"><i className="fab fa-linkedin-in"></i></a>
                                <a className="btn btn-outline-light btn-social me-2" href="#"><i className="fab fa-twitter"></i></a>
                                <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-whatsapp"></i></a>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-light mb-4">Contact Info</h5>
                            <p className="mb-2 text-white-50">
                                <i className="fa fa-map-marker-alt me-3"></i>
                                Zambia, UK, South Africa & USA
                            </p>
                            <p className="mb-2 text-white-50">
                                <i className="fa fa-phone-alt me-3"></i>
                                +260-978770051
                            </p>
                            <p className="mb-2 text-white-50">
                                <i className="fa fa-phone-alt me-3"></i>
                                +1-407-399-6572
                            </p>
                            <p className="mb-2 text-white-50">
                                <i className="fa fa-envelope me-3"></i>
                                gsharma@unicellusa.com
                            </p>
                            <p className="mb-2 text-white-50">
                                <i className="fa fa-envelope me-3"></i>
                                info@unicellusa.com
                            </p>
                        </div>

                        {/* Quick Links */}
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-light mb-4">Quick Links</h5>
                            <NavLink to="/" className="btn btn-link text-white-50 d-block text-start p-0 mb-2 text-light" onClick={handleClick}>
                             <i className="bi bi-arrow-right text-primary me-2"></i>Home
                            </NavLink>
                            <NavLink to="/Aboutus" className="btn btn-link text-white-50 d-block text-start p-0 mb-2" onClick={handleClick}>
                                <i className="bi bi-arrow-right text-primary me-2"></i>About Us
                            </NavLink>
                            <NavLink to="/Amenities" className="btn btn-link text-white-50 d-block text-start p-0 mb-2" onClick={handleClick}>
                                <i className="bi bi-arrow-right text-primary me-2"></i>Services
                            </NavLink>
                            <NavLink to="/Contactus" className="btn btn-link text-white-50 d-block text-start p-0 mb-2" onClick={handleClick}>
                                <i className="bi bi-arrow-right text-primary me-2"></i>Contact Us
                            </NavLink>
                        </div>

                        {/* Newsletter */}
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-light mb-4">Stay Connected</h5>
                            <p className="text-white-50">
                                Subscribe to our newsletter for the latest updates on industrial innovations and global projects.
                            </p>
                            <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                                <input 
                                    className="form-control border-0 w-100 py-3 ps-4 pe-5"
                                    type="email"
                                    placeholder="Your email"
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                                >
                                    Subscribe
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Copyright */}
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                © {new Date().getFullYear()}{" "}
                                <span className="border-bottom">
                                    Unicell Technologies Limited
                                </span>, All Rights Reserved.
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                Designed by  
                                    <a 
                                        href="https://pearlcons.com/" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="border-bottom text-decoration-none"
                                        style={{ color: 'inherit' }}
                                    >
                                        Pearlcon Technologies
                                    </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;